import { render, staticRenderFns } from "./ShareNative.vue?vue&type=template&id=720c629e&scoped=true&"
import script from "./ShareNative.vue?vue&type=script&lang=ts&"
export * from "./ShareNative.vue?vue&type=script&lang=ts&"
import style0 from "./ShareNative.vue?vue&type=style&index=0&id=720c629e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720c629e",
  null
  
)

export default component.exports